import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import TextImageCard from 'src/components/resources/_TextImageCard/TextImageCard';
import { TextImageCardFields } from 'src/components/resources/_TextImageCard/TextImageCardFields';

type ResourceCardProps = ComponentProps & {
	fields: TextImageCardFields & {
		Subheading: Field<string>;
	};
};

export default function ResourceCard(props: ResourceCardProps) {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && !props.fields?.Text?.value === undefined) {
		return <></>;
	}

	return (
		<section className="maxWidth">
			<TextImageCard {...props.fields} />
		</section>
	);
}
